export default __webpack_public_path__ + "static/media/Merienda-Regular.650d7290.ttf";